module.exports = __webpack_public_path__ + "cdcdea1a83fc234ba92c8dc6d20086d7.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/graviton_-_agudabold_1-webfont.woff
// module id = 1312
// module chunks = 28